import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import Button from '../Button';
import Card from '../Card';

function NotFoundCard(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center">
      <Card padding className="flex flex-col items-center space-y-4">
        <div className="text-8xl">404</div>
        <div className="text-xl font-bold">
          {t('not_found_page.title', 'Page not found')}
        </div>
        <p className="text-center text-gray-600">
          {t(
            'not_found_page.description',
            'Sorry, we were unable to find the page you were looking for.',
          )}
        </p>
        <Button onClick={() => navigate('/')}>
          {t('buttons.back_to_home', 'Back to Home')}
        </Button>
      </Card>
    </div>
  );
}

export default NotFoundCard;
